// import React, { useEffect, useState } from 'react';
// import bannerImage from '../img/aaaservices/3d-img-1.jpg'; // Update to your image path

// import OnlyButtonrange from './OnlyButtonrange';


// const Banner = () => {
//     const [animate, setAnimate] = useState(false);
//     const [showForm, setShowForm] = useState(false);

//     const handleOpenForm = () => setShowForm(true);
//     const handleCloseForm = () => setShowForm(false);

//     useEffect(() => {
//         setAnimate(true);
//     }, []);

//     return (
//         <>
//             <style>{`
//         .banner-container {
//           position: relative;
//           width: 100%;
//           height: 112vh;
//           max-height: 762px;
//           overflow: hidden;
//           margin-top:50px;
//         }

//         .banner-image {
//           width: 100%;
//           height: 112vh;
//           max-height:762px;
//           object-fit: cover;
//         }

//         .banner-overlay {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background-color: rgba(0, 0, 0, 0.5);
//           z-index: 1;
//         }

//         .banner-text {
//           position: absolute;
//           bottom: 20%;
//           left: 5%;
//           color: white;
//           z-index: 2;
//           opacity: 0;
//           transform: translateY(50px);
//           transition: all 1s ease-out;
//           max-width: 700px;
//         }

//         .banner-text.animate {
//           opacity: 1;
//           transform: translateY(0);
//         }

//         .banner-heading {
//           font-size: 2.5rem;
//           font-weight: 700;
//           margin: 0;
//         }

//         .banner-heading .blue {
//           color: white;
//           text-transform: uppercase;
//         }

//         .banner-heading span:last-child {
//           color: gold;
//         }

//         .banner-subheading {
//           font-size: 1.125rem;
//           font-weight: 400;
//           margin-top: 15px;
//           line-height: 1.6;
//           text-align: left;
//           max-width: 600px;
//         }

//         .banner-text button {
//           margin-top: 20px;
//           background-color: #FACC15;
//           color: black;
//           padding: 12px 24px;
//           border-radius: 9999px;
//           border: none;
//           font-weight: 600;
//           cursor: pointer;
//         }

//         @media screen and (max-width: 768px) {
//           .banner-heading {
//             font-size: 2rem;
//           }

//           .banner-subheading {
//             font-size: 1rem;
//             max-width: 90%;
//           }
//         }

//         @media screen and (max-width: 480px) {
//           .banner-heading {
//             font-size: 1.5rem;
//           }

//           .banner-subheading {
//             font-size: 0.875rem;
//           }
//         }

//         .overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background-color: rgba(0, 0, 0, 0.6);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 1000;
//         }

//         .modal {
//           background-color: #fff;
//           padding: 30px;
//           border-radius: 12px;
//           width: 90%;
//           max-width: 400px;
//           box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
//           position: relative;
//         }

//         .modal h3 {
//           margin-bottom: 20px;
//           color: rgb(12 133 155);
//         }

//         .modal input {
//           width: 100%;
//           padding: 10px;
//           margin-bottom: 12px;
//           border-radius: 6px;
//           border: 1px solid #ccc;
//         }

//         .modal .submit-button {
//           background-color: #FACC15;
//           color: #fff;
//           padding: 10px;
//           border: none;
//           border-radius: 6px;
//           width: 100%;
//           font-weight: bold;
//           cursor: pointer;
//           margin-top: 10px;
//         }

//         .modal .close-button {
//           position: absolute;
//           top: 10px;
//           right: 10px;
//           background: transparent;
//           border: none;
//           font-size: 18px;
//           cursor: pointer;
//         }
//       `}</style>

//             <div className="banner-container">
//                 <img src={bannerImage} alt="Banner" className="banner-image" />
//                 <div className="banner-overlay"></div>
//                 <div className={`banner-text ${animate ? 'animate' : ''}`}>
//                     <h1 className="banner-heading">
//                         <span className="blue">Mechanical Engineering  </span><span>SOLUTIONS</span>
//                     </h1> 
//                     <p className="banner-subheading">
//                     At Envision Integrated Services, we specialize in optimizing operations, enhancing efficiency, and fostering innovation through advanced methodologies. Our team of engineers blends technical excellence with extensive knowledge of industry standards to provide tailored solutions that precisely align with your requirements.


//                     </p>
//                     <button onClick={handleOpenForm}>Book Your Free Trial Class now →</button>
//                 </div>

//                 {showForm && (
//                     <div className="overlay">
//                         <div className="modal">
//                             <h3>Welcome to Envision Group</h3>
//                             <input type="text" placeholder="Name" />
//                             <input type="email" placeholder="Email" />
//                             <input type="tel" placeholder="Mobile" />
//                             <button className="submit-button">Submit</button>
//                             <button onClick={handleCloseForm} className="close-button">X</button>
//                         </div>
//                     </div>
//                 )}
//             </div>
           
//             <OnlyButtonrange/>
//         </>
//     );
// };

// export default Banner;







// import React, { useEffect, useState } from 'react';
// import bannerImage from '../img/aaaservices/Virtual-Reality-1.jpg';
// import OnlyButtonrange from './OnlyButtonrange';

// const Banner = () => {
//   const [animate, setAnimate] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);
//   const [step, setStep] = useState(1);
//   const [formData, setFormData] = useState({
//     email: "",
//     phone: "",
//   });

//   const courseDetails = {
//     name: "Robotics Virtual Simulation",
//     description: "An interactive hands-on simulation course in robotics.",
//     fee: "₹4,999",
//   };

//   const handleInputChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = () => {
//     setStep(2); // Move to the next step
//   };
//   useEffect(() => {
//     setAnimate(true);
//   }, []);

//   return (
//     <>
//       <style>{`
//         .banner-container {
//           position: relative;
//           width: 100%;
//           height: 600px;
//           overflow: hidden;
//           margin-top: 50px;
//         }

//         .banner-image {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }

//         .banner-overlay {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background-color: rgba(0, 0, 0, 0.5);
//           z-index: 1;
//         }

//         .banner-text {
//           position: absolute;
//           bottom: 10%;
//           left: 5%;
//           color: white;
//           z-index: 2;
//           opacity: 0;
//           transform: translateY(50px);
//           transition: all 1s ease-out;
//           max-width: 700px;
//         }

//         .banner-text.animate {
//           opacity: 1;
//           transform: translateY(0);
//         }

//         .banner-heading {
//           font-size: 32px;
//           font-weight: bold;
//           margin: 0;
//           font-family: snas,serif;
//         }

//         .banner-heading .blue {
//           color: white;
//           text-transform: uppercase;
//         }

//         .banner-heading span:last-child {
//           color: Orange;
//         }

//         .banner-subheading {
//           font-size: 18px;
//           font-weight: 400;
//           margin-top: 15px;
//           line-height: 1.6;
//           text-align: left;
//           max-width: 600px;
//         }

//         .button-group {
//           display: flex;
//           gap: 10px;
//           margin-top: 20px;
//           flex-wrap: wrap;
//         }

//         .banner-button {
//           background-color: #007bff;
//           color: white;
//           padding: 10px 18px;
//           border-radius: 9999px;
//           border: none;
//           font-weight: 600;
//           cursor: pointer;
//           font-size: 14px;
//           transition: background 0.3s ease;
//         }

//         .banner-button:hover {
//           background-color: #0056b3;
//         }

//         .star-rating {
//           color: gold;
//           font-size: 1.2rem;
//           margin-top: 10px;
//         }

//         @media screen and (max-width: 768px) {
//           .banner-heading {
//             font-size: 2rem;
//           }
//           .banner-subheading {
//             font-size: 1rem;
//             max-width: 90%;
//           }
//         }

//         @media screen and (max-width: 480px) {
//           .banner-heading {
//             font-size: 1.5rem;
//           }
//           .banner-subheading {
//             font-size: 0.875rem;
//           }
//         }

       

       
       

       
        

       
//       `}</style>

//       <div className="banner-container">
//         <img src={bannerImage} alt="Banner" className="banner-image" />
//         <div className="banner-overlay"></div>
//         <div className={`banner-text ${animate ? 'animate' : ''}`}>
//           <h1 style={{fontFamily:'sans-serif'}} className="banner-heading">
//             <span className="blue">6 Axis Industrial Robotic Virtual </span>
//             <span>Simulation</span>
//           </h1>
//           <p style={{fontFamily:'sans-serif'}} className="banner-subheading">
//            Adoption of 6-axis industrial robots is revolutionizing sectors such as manufacturing and logistics, offering precise automation for tasks like welding and assembly. Virtual simulation allows for cost-effective testing and optimization without physical hardware, reducing risks and costs. As the demand for automation grows, and with advancements in AI and IoT, mastering robotic programming and simulation is crucial for staying ahead in this dynamic field.
//           </p>

//           <div className="button-group">
           
//             <button className="banner-button">Brochure</button>
//             <button className="banner-button">Enquiry</button>
//             <div>
//       <button className="banner-button" onClick={() => setShowPopup(true)}>
//         Book Now
//       </button>

//       {showPopup && (
//         <div className="popup-overlay">
//           <div className="popup-content">
//             <span className="close-btn" onClick={() => setShowPopup(false)}>
//               &times;
//             </span>

//             {step === 1 ? (
//               <div className="form-step">
//                 <h2 style={{fontFamily:'sans,serif',fontSize:'20px',fontWeight:'bold',color:'orange'}}>Enter your details</h2>
//                 <input
//                   type="email"
//                   name="email"
//                   placeholder="Email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                 />
//                 <input
//                   type="tel"
//                   name="phone"
//                   placeholder="Phone Number"
//                   value={formData.phone}
//                   onChange={handleInputChange}
//                 />
//                 <button onClick={handleSubmit}>Submit</button>
//               </div>
//             ) : (
//               <div className="form-step">
//                 <h2 style={{fontFamily:'sans,serif',fontSize:'20px',fontWeight:'bold',color:'orange'}}>Confirm Your Details</h2>
//                 <p style={{textAlign:'left',color:'orange',fontFamily:'sans-serif'}}><strong>Email:</strong> {formData.email}</p>
//                 <p style={{textAlign:'left',color:'orange',fontFamily:'sans-serif'}}><strong>Phone:</strong> {formData.phone}</p>
//                 <hr />
//                 <p style={{textAlign:'left',color:'blue',fontFamily:'sans-serif'}}><strong>Course:</strong> {courseDetails.name}</p>
//                 <p style={{textAlign:'left',color:'blue',fontFamily:'sans-serif'}}><strong>Description:</strong> {courseDetails.description}</p>
//                 <p style={{textAlign:'left',color:'blue',fontFamily:'sans-serif'}}><strong>Fee:</strong> {courseDetails.fee}</p>
//                 <button className="pay-btn">Pay Now</button>
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       <style>{`
//         .banner-button {
//           padding: 10px 20px;
//           background-color: #007bff;
//           color: white;
//           border: none;
//           cursor: pointer;
//           border-radius: 30px;
//         }

//         .popup-overlay {
//           position: fixed;
//           top: 0; left: -77px;
//           width: 100vw; height: 128vh;
//           background-color: rgba(0, 0, 0, 0.6);
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           z-index: 999;
//           margin-top:-245px;
//         }

//         .popup-content {
//           background: white;
//           padding: 30px;
//           border-radius: 10px;
//           width: 100%;
//           max-width: 400px;
//           position: relative;
//         }

//         .close-btn {
//           position: absolute;
//           top: 10px; right: 15px;
//           font-size: 20px;
//           cursor: pointer;
//           color:orange;
//         }

//         .form-step input {
//           width: 100%;
//           margin: 10px 0;
//           padding: 10px;
//           border-radius: 5px;
//           border: 1px solid #ccc;
//         }

//         .form-step button {
//           padding: 10px;
//           width: 100%;
//           background-color: orange;
//           color: white;
//           border: none;
//           border-radius: 5px;
//           margin-top: 10px;
//         }

//         .pay-btn {
//           background-color: Orange !important;
//         }
//       `}</style>
//     </div>
             
//           </div>

//           <div className="star-rating">⭐⭐⭐⭐⭐</div>
//         </div>

        
        
//       </div>

//       <OnlyButtonrange />
//     </>
//   );
// };

// export default Banner;





import React, { useEffect, useState } from 'react';
import bannerImage from '../img/aaaservices/Virtual-Reality-1.jpg';
import OnlyButtonrange from './OnlyButtonrange';
import logo from "../img/aaaservices/LogoIIAHead.png";

import brochure from './IIA_ROBOTICS_VIRTUAL.pdf'; 

import jsPDF from "jspdf";
const Banner = () => {
  const [animate, setAnimate] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({ email: '', phone: '' });
    const [loading, setLoading] = useState(false);

  const courseDetails = {
    name: 'Robotics Virtual Simulation',
    description: 'An interactive hands-on simulation course in robotics.',
    fee: '₹4,999',
  };

  useEffect(() => {
    setAnimate(true);
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    setStep(2);
  };

const handleBrochureDownload = () => {
    const link = document.createElement('a');
    link.href = '/brochure.docx'; // brochure file must be in public folder
    link.setAttribute('download', 'Education-Brochure.docx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const generatePDF = () => {
         
         
      const doc = new jsPDF();

  // Add Logo
  const img = new Image();
  img.src = logo;

  img.onload = () => {
    doc.addImage(img, "PNG", 10, 10, 40, 15); // Logo: x, y, width, height

    // Invoice Title
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("TAX INVOICE", 160, 20);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("Invoice #: INV2025-0001", 160, 26);
    doc.text("Invoice date: 26/05/2025", 160, 31);

    // Supplier Details
    let y = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Supplier details:", 10, y);

    doc.setFont("helvetica", "normal");
    y += 5;
    doc.text("International Institute of Automation", 10, y);
    y += 5;
    doc.text("5th Floor, ABC Tech Tower, Bengaluru, India - 560001", 10, y);
    y += 5;
    doc.text("GSTIN: 29AAACB1234J1Z1", 10, y);
    y += 5;
    doc.text("PAN No: AAACB1234J", 10, y);

    // Recipient Details
    y = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Recipient details:", 140, y);

    doc.setFont("helvetica", "normal");
    y += 5;
    doc.text("Aarish Kumar", 140, y);
    y += 5;
    doc.text("aarish.k0094@gmail.com", 140, y);
    y += 5;
    doc.text("Uttar Pradesh, India", 140, y);

    // Table Headers
    y = 80;
    doc.setFont("helvetica", "bold");
    doc.setFillColor(230, 230, 230);
    doc.rect(10, y, 190, 10, 'F');
    doc.text("Description", 12, y + 7);
    doc.text("HSN Code", 70, y + 7);
    doc.text("Quantity", 95, y + 7);
    doc.text("Taxable Value", 115, y + 7);
    doc.text("IGST (18%)", 150, y + 7);
    doc.text("Total", 180, y + 7);

    // Table Row
    y += 12;
    doc.setFont("helvetica", "normal");
    doc.text("Robotics Virtual Simulation Course", 12, y);
    doc.text("9984 33", 70, y);
    doc.text("1.0", 100, y);
    doc.text("10,000", 118, y);
    doc.text("1,800", 154, y);
    doc.text("11,800", 180, y, { align: "right" });

    // Total Row
    y += 10;
    doc.setFont("helvetica", "bold");
    doc.text("Total", 12, y);
    doc.text("10,000", 118, y);
    doc.text("1,800", 154, y);
    doc.text("INR 11,800.00", 200, y, { align: "right",marginTop:'20px' });

    // Footer Note
    y += 15;
    doc.setFont("helvetica", "italic");
    doc.setFontSize(9);
    doc.text("This is a system-generated invoice and does not require a signature.", 10, y);

    // Save PDF
    doc.save("Tax_Invoice.pdf");
  }
};
      
      
        const initiatePayment = async () => {
          setLoading(true);
      
          // Payment and transaction details
      
          // Razorpay Payment Options for paid courses
          var options = {
            key: "rzp_test_oqm83qg9Z710lA",
            key_secret: "eaHmzOnTh2AqXLFRFWavB29c",
            amount: 1 * 100, // Convert price to paise
            currency: "INR",
            payment_capture: true,
            name: "International Institute Of Automate",
            handler: async function (response) {
              alert(
                "Thanks For Your Interest \n Your Payment has been successfully completed"
              );
              generatePDF();
              // Call API to update payment status
      
            },
            notes: {
              address: "International Institute Of Automate",
            },
            theme: {
              color: "#3399cc",
            },
          };
      
          var pay = new window.Razorpay(options);
          pay.open();
        }


  return (
    <>
      <style>{`
        .banner-container {
          position: relative;
          width: 100%;
          height: 750px;
          overflow: hidden;
          margin-top: 0px;
        }

        .banner-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .banner-overlay {
          position: absolute;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background-color: rgba(5, 42, 102, 0.5);
          z-index: 1;
        }

        .banner-text {
          position: absolute;
          bottom: 18%;
          left: 5%;
          color: white;
          z-index: 2;
          opacity: 0;
          transform: translateY(50px);
          transition: all 1s ease-out;
          max-width: 700px;
        }

        .banner-text.animate {
          opacity: 1;
          transform: translateY(0);
        }

        .banner-heading {
          font-size: 32px;
          font-weight: bold;
          margin: 0;
          font-family: sans-serif;
        }

        .banner-heading .blue {
          color: white;
          text-transform: uppercase;
        }

        .banner-heading span:last-child {
          color: orange;
        }

        .banner-subheading {
  font-size: 18px;
  font-weight: 400;
  margin-top: 15px;
  line-height: 1.6;
  text-align: justify; /* 👈 This justifies the text */
  text-justify: inter-word;
  max-width: 600px;
}

        .button-group {
  display: flex;
  // justify-content: center; /* 👈 buttons ko horizontally center align karega */
  align-items: left;      /* 👈 (optional) vertically center karega */
  gap: 15px;                /* buttons ke beech ka gap */
  margin-top: 20px;
  flex-wrap: wrap;
}

.banner-button {
  background-color:rgb(255, 162, 0);
  color: white;
  padding: 14px 24px;         /* 👈 height aur width badh gayi */
  border-radius: 9999px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  font-size: 16px;            /* 👈 text size bhi thoda bada */
  transition: background 0.3s ease;
  min-width: 140px;           /* 👈 fixed minimum width */
  text-align: center;
}

.banner-button:hover {
  background-color: #0056b3;
}


       

        .star-rating {
          color: gold;
          font-size: 1.2rem;
          margin-top: 10px;
        }

        .popup-overlay {
          position: fixed;
          top: 0; left: 0;
          width: 100vw; height: 100vh;
          background-color: rgba(0, 0, 0, 0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 999;
          padding: 20px;
        }

        .popup-content {
          background: white;
          padding: 20px;
          border-radius: 10px;
          width: 100%;
          max-width: 400px;
          position: relative;
          box-shadow: 0 0 10px rgba(0,0,0,0.3);
        }

        .close-btn {
          position: absolute;
          top: 10px; right: 15px;
          font-size: 20px;
          cursor: pointer;
          color: orange;
        }

        .form-step input {
          width: 100%;
          margin: 10px 0;
          padding: 10px;
          border-radius: 5px;
          border: 1px solid #ccc;
        }

        .form-step button {
          padding: 10px;
          width: 100%;
          background-color: orange;
          color: white;
          border: none;
          border-radius: 5px;
          margin-top: 10px;
          font-weight: bold;
        }

        .pay-btn {
          background-color: orange !important;
        }

.transparent-box {
  position: absolute;
  top: 210px;
  right: 1%;
  width: 30%;
  min-height: 400px; /* increased height */
  background: rgba(255, 255, 255, 0.15);
  padding: 25px;
  color: #fff;
  border-radius: 10px;
  backdrop-filter: blur(6px);
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.transparent-box h2 {
  font-size: 24px;
  margin-bottom: 15px;
}

.event-details {
  list-style-type: none;
  padding: 0;
  margin: 0 0 20px 0;
  line-height: 1.8;
  font-size: 16px;
}

.event-details li strong {
  color: #fff;
  font-weight: 600;
}

.book-now-button {
  background-color: #ffa200;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.book-now-button:hover {
  background-color: blue;
}

@media screen and (max-width: 768px) {
  .transparent-box {
    position: relative;
    width: 90%;
    margin: 20px auto;
    top: -35;
    right: 0;
    min-height: auto;
    padding: 20px;
  }
}




        

        @media (max-width: 768px) {
          .banner-heading {
            font-size: 1.8rem;
          }
          .banner-subheading {
            font-size: 1rem;
            max-width: 90%;
          }
        }

        @media (max-width: 480px) {
          .banner-heading {
            font-size: 1.5rem;
          }
          .banner-subheading {
            font-size: 0.9rem;
          }
          .popup-content {
            max-width: 90%;
          }


/* Ensure container adapts on mobile */
@media (max-width: 768px) {
  .banner-container {
    height: auto;
    flex-direction: column;
    display: flex;
    align-items: center;
    padding-bottom: 30px;
    margin-top:-560px;
  }

  .banner-text {
    position: relative;
    bottom: auto;
    left: auto;
    transform: none;
    opacity: 1 !important;
    text-align: center;
    margin-top: 20px;
    padding: 0 15px;
  }

  .banner-heading {
    font-size: 1.6rem;
    line-height: 1.4;
  }

  .banner-subheading {
    font-size: 1rem;
    text-align: justify;
    max-width: 100%;
  }

  .transparent-box {
    position: relative;
    width: 90%;
    margin-top: 20px;
    min-height: auto;
    padding: 20px;
    top: auto;
    right: auto;
    backdrop-filter: blur(4px);
  }

  .button-group {
    justify-content: center;
  }
}


        }
      `}</style>

      <div className="banner-container">
  <img src={bannerImage} alt="Banner" className="banner-image" />
  <div className="banner-overlay"></div>

  {/* Transparent text box on right side */}
 <div className="transparent-box">
  <h2>Robotic Virtual Simulation</h2>
  <ul className="event-details">
    <li><strong>Date:</strong> Fri 16 May 2025</li>
    <li><strong>Time:</strong> 8:00 PM</li>
    <li><strong>Duration:</strong> 5 Hours</li>
    <li><strong>Age Limit:</strong> 21yrs +</li>
    <li><strong>Languages:</strong> Telugu, English, Hindi</li>
    <li><strong>Category:</strong> Instrumental, Regional</li>
    <li><strong>Artistry:</strong> Hyderabad</li>
    <li><strong>Price:</strong> ₹2000 onwards</li>
    <li><strong>Status:</strong> Available</li>
  </ul>
  <button className="banner-button" onClick={() => setShowPopup(true)}>Book Now</button>
</div>


  <div className={`banner-text ${animate ? 'animate' : ''}`}>
    <h1 className="banner-heading">
      <span className="blue">6 Axis Industrial Robotic Virtual </span>
      <span>Simulation</span>
    </h1>
    <p className="banner-subheading">
      Adoption of 6-axis industrial robots is revolutionizing sectors such as manufacturing and logistics, offering precise automation for tasks like welding and assembly. Virtual simulation allows for cost-effective testing and optimization without physical hardware, reducing risks and costs. As the demand for automation grows, and with advancements in AI and IoT, mastering robotic programming and simulation is crucial for staying ahead in this dynamic field.
    </p>
   

<div style={{marginTop:'50px'}}>
    <div className="button-group">
      <div className="star-rating">⭐⭐⭐⭐⭐</div>
      <a 
  className='banner-button' 
  href={brochure} 
  download="IIA_ROBOTICS_VIRTUAL.pdf" 
  style={{ textDecoration: 'none', color: 'white', cursor: 'pointer' }}
>
  Brochure
</a>
      <button className="banner-button" onClick={() => window.location.href = '/contact'}>Enquiry</button>
     <button
  className="banner-button"
  onClick={() => window.open('https://play.google.com/store/apps/details?id=iia.app', '_blank')}
>
  Go to App
</button>


    </div>

    </div>
  </div>

   </div>



      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <span className="close-btn" onClick={() => setShowPopup(false)}>&times;</span>

            {step === 1 ? (
              <div className="form-step">
                <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: 'orange' }}>Enter your details</h2>
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
                <button onClick={handleSubmit}>Submit</button>
              </div>
            ) : (
              <div className="form-step">
                <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: 'orange' }}>Confirm Your Details</h2>
                <p style={{ color: 'black',textAlign:'left',fontFamily:'sans-serif' }}><strong>Email:</strong> {formData.email}</p>
                <p style={{ color: 'black',textAlign:'left',fontFamily:'sans-serif' }}><strong>Phone:</strong> {formData.phone}</p>
                <hr />
                <p style={{ color: 'blue',textAlign:'left',fontFamily:'sans-serif' }}><strong>Course:</strong> {courseDetails.name}</p>
                <p style={{ color: 'blue',textAlign:'left',fontFamily:'sans-serif' }}><strong>Description:</strong> {courseDetails.description}</p>
                <p style={{ color: 'blue',textAlign:'left',fontFamily:'sans-serif' }}><strong>Fee:</strong> {courseDetails.fee}</p>
                {/* <button className="pay-btn">Pay Now</button> */}
                <button
                        className="pay-btn" onClick={initiatePayment} disabled={loading}>
                        {loading ? 'Processing...' : 'Pay Now'}
                      </button>
              </div>
            )}
          </div>
        </div>
      )}
<div style={{marginTop:'-292px'}}>
      <OnlyButtonrange />
      </div>
    </>
  );
};

export default Banner;

